/** Offset from server time: serverNow() = Date.now() + offsetMs when a sample exists. */
let offsetMs = 0;
let bestRttMs: number | null = null;
let hasSample = false;

/** Current time aligned to the server clock; falls back to device time with no sample. */
export function serverNow(): number {
  return Date.now() + (hasSample ? offsetMs : 0);
}

/**
 * Record a server-time sample from an axios response.
 * Keeps the offset from the smallest round-trip sample.
 */
export function recordServerTimeSample(
  serverTimeMs: number,
  requestStartedAtMs: number,
  receivedAtMs: number,
): void {
  if (!Number.isFinite(serverTimeMs)) return;
  const rttMs = receivedAtMs - requestStartedAtMs;
  if (rttMs < 0) return;
  const sampleOffset = serverTimeMs - receivedAtMs;
  if (bestRttMs === null || rttMs < bestRttMs) {
    bestRttMs = rttMs;
    offsetMs = sampleOffset;
    hasSample = true;
  }
}

/** Test helper: simulate a device clock skew without axios. */
export function setServerTimeOffsetForTests(nextOffsetMs: number): void {
  offsetMs = nextOffsetMs;
  bestRttMs = 0;
  hasSample = true;
}

/** Test helper: restore default device-time behavior. */
export function resetServerTimeOffsetForTests(): void {
  offsetMs = 0;
  bestRttMs = null;
  hasSample = false;
}
